import React, { useState } from 'react';
import Home from './components/Home';
import Quiz from './components/Quiz';
import Score from './components/Score';

function App() {
  const [screen, setScreen] = useState('home'); // 'home', 'quiz', 'score'
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [score, setScore] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(0);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setScreen('quiz');
  };

  const handleQuizComplete = (finalScore, total) => {
    setScore(finalScore);
    setTotalQuestions(total);
    setScreen('score');
  };

  const handlePlayAgain = () => {
    setScore(0);
    setTotalQuestions(0);
    setSelectedCategory(null);
    setScreen('home');
  };

  return (
    <div className="App">
      {screen === 'home' && <Home onCategorySelect={handleCategorySelect} />}
      {screen === 'quiz' && (
        <Quiz 
          category={selectedCategory} 
          onQuizComplete={handleQuizComplete} 
        />
      )}
      {screen === 'score' && (
        <Score 
          score={score} 
          total={totalQuestions} 
          onPlayAgain={handlePlayAgain} 
        />
      )}
    </div>
  );
}

export default App;
